import {
  googleCalendarEmbedScheduleIdFI,
  googleCalendarEmbedScheduleIdSE,
} from "../constants";
import { CountryCode, type SupportedLanguage } from "../types/common";

// Anchored: the result becomes an iframe `src`, and a wrong partial match
// embeds a different advisor's calendar.
// Anchored: the result becomes an iframe `src`, and a wrong partial match
// embeds a different advisor's calendar.
const GOOGLE_SCHEDULE_URL =
  /^https:\/\/calendar\.google\.com\/(?:calendar\/)?(?:u\/\d+\/)?appointments\/schedules\/([A-Za-z0-9_-]+)(?:\/(?=[?#]|$))?(?=[?#]|$)/;

const EMBED_LANGUAGES: readonly SupportedLanguage[] = ["sv", "en", "fi"];

const resolveEmbedLanguage = (
  locale?: string,
): SupportedLanguage | undefined => {
  const baseSubtag = locale?.split("-")[0]?.toLowerCase();

  return EMBED_LANGUAGES.find((language) => language === baseSubtag);
};

const composeEmbedUrl = (
  scheduleId: string,
  language: SupportedLanguage | undefined,
): string =>
  `https://calendar.google.com/calendar/appointments/schedules/${scheduleId}?gv=true${
    language === undefined ? "" : `&hl=${language}`
  }`;

export const isGoogleScheduleUrl = (link?: string | null): boolean =>
  GOOGLE_SCHEDULE_URL.test(link?.trim() ?? "");

export interface IResolveCalendarEmbedUrlParams {
  countryCode: CountryCode;
  calendarLink?: string | null;
  locale?: string;
}

export const resolveCalendarEmbedUrl = ({
  countryCode,
  calendarLink,
  locale,
}: IResolveCalendarEmbedUrlParams): string => {
  const defaultByCountry: Readonly<Record<CountryCode, string>> = {
    [CountryCode.SE]: googleCalendarEmbedScheduleIdSE,
    [CountryCode.FI]: googleCalendarEmbedScheduleIdFI,
  };

  const scheduleId = calendarLink?.trim().match(GOOGLE_SCHEDULE_URL)?.[1];

  return composeEmbedUrl(
    scheduleId ?? defaultByCountry[countryCode],
    resolveEmbedLanguage(locale),
  );
};
